import { autocompleteClasses } from "@mui/material/Autocomplete";
import { styled } from "@mui/material/styles";
import { Autocomplete } from "components/autocomplete";
import { Input } from "components/input";
import { type State } from "utils/state";

export const ApartmentInput = styled(Input, {
  label: "apartment-input",
})`
  flex: 0 0 ${({ theme }) => theme.spacing(12)};
`;

export const StateInput = styled(Autocomplete<State, false, true>, {
  label: "state-input",
})`
  width: 100%;

  .${autocompleteClasses.input} {
    padding: 21px 0 4px !important;
  }
`;
